import Alpine from 'alpinejs';
import persist from '@alpinejs/persist';
import collapse from '@alpinejs/collapse';

import sortable from './sortable';
import editor from './editor';
import imageSelector from './image-selector';
import contentMigration from '../admin/content-migration';

import tippy from 'tippy.js';

declare global {
  interface Window {
    Alpine: typeof Alpine;
  }
}

window.Alpine = Alpine;

Alpine.plugin(persist);
Alpine.plugin(collapse);

Alpine.data('sortable', sortable);
Alpine.data('editor', editor);
Alpine.data('imageSelector', imageSelector);
Alpine.data('contentMigration', contentMigration);

Alpine.start();

document.addEventListener('turbo:load', () => {
  tippy('[data-tippy-content]');
});
